import {
    Box,
    Grid,
    Divider,
    Stack,
    TextField,
    Button,
    Modal,
    IconButton,
    InputAdornment,
    Radio,
    FormControl,
    RadioGroup,
  } from "@mui/material";
  import { Check, Error, Visibility, VisibilityOff } from "@mui/icons-material";
  import "../Styles/AdminFacility.css";
  import { Link, useLocation, useParams } from "react-router-dom";
  import {
    createCareFacility,
  } from "../../common/constants/globalconstants";
  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import EmailInputField from "../../common/EmailInputField";
  import { useSelector } from "react-redux";
  import usePreventBFCache from "../../common/usePreventBFCache";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    padding: "20px !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    maxHeight: "80%",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    borderRadius:"10px"
  };
  
  const facilityData = {
    id: 0,
    accountNumber: "",
    careFacilityName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    contactPerson: "",
    email: "",
    reliableHealth: "No",
  };
  
  function StandAloneCareFacility() {
    usePreventBFCache();
    const navigate = useNavigate();
    const location = useLocation();
    const { action } = useParams();
    const [data, setData] = useState(facilityData);
    const [open, setOpen] = useState(false);
    const [errormodalopen, seterrormodalOpen] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [error, setError] = useState({});
    const [emailError, setEmailError] = useState({});
    const [acntNumError, setAcntNumError] = useState({});
    const [phoneError, setPhoneError] = useState({});
    const [facilityName, setFacilityName] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [hasFocus, setFocus] = useState(false);
    const [showAccnt, setShowAccnt] = useState(false);
    const storeuser = useSelector((state) => state.storeuser);
    var displayMsg = action === "edit" ? "updated" : "added";
  
    useEffect(() => {
      if (action === "edit") {
        const facilityDetails = location.state;
        setData({
          ...data,
          id: facilityDetails.id,
          accountNumber: facilityDetails.accountNumber,
          careFacilityName: facilityDetails.companyName,
          address: facilityDetails.address,
          city: facilityDetails.city,
          state: facilityDetails.state,
          zip: facilityDetails.zip,
          phone: facilityDetails.telephoneNum,
          contactPerson: facilityDetails.contactPerson,
          email: facilityDetails.email,
          reliableHealth: facilityDetails.isReliable === "Y" ? "Yes" : 
                              facilityDetails.isReliable === "N" ? "No" : "No"
        });
      }
    }, [location]);
  
    const changeHandler = (e) => {
      e.preventDefault();
      const regex = /^[0-9]*$/;
      if (e.target.name === "accountNumber") {    
        if (e.target.value === "") {
          setData({ ...data, accountNumber: e.target.value });
        }
        if (regex.test(e.target.value)) {
          validateAccountField(e);
          const value = e.target.value;
          setData({ ...data, accountNumber: value });
          if(value.length ===10){
            setAcntNumError({});
            setError({ ...error, accountNumber:""})
           }
          
        }
      } 
       else if  (e.target.name === "phone") {
         if (e.target.value === "") {
          setData({ ...data, phone: e.target.value });
          setPhoneError({});
         }
         if (regex.test(e.target.value)) {
          validatePhoneField(e.target.value);
          const value = e.target.value;
           setData({ ...data, phone: value }); 
           if(value.length ===10){
            setPhoneError({});
            setError({ ...error, phone:""})
           }
         }       
        }

        else if(e.target.name === "careFacilityName"){
          const value = e.target.value;
          setData({ ...data, careFacilityName: e.target.value });
          setError({...error, careFacilityName: "" });

          if(value === "" || value === undefined || value === null){
          setError({...error, careFacilityName: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "address"){
          const value = e.target.value;
          setData({ ...data, address: e.target.value });
          setError({...error, address: "" })

          if(value === "" || value === undefined || value === null){
          setError({...error, address: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "city"){
          const value = e.target.value;
          setData({ ...data, city: e.target.value });
          setError({...error, city: "" })

          if(value === "" || value === undefined || value === null){
          setError({...error, city: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "state"){
          const value = e.target.value;
          setData({ ...data, state: e.target.value });
          setError({...error, state: "" });

          if(value === "" || value === undefined || value === null){
          setError({...error, state: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "zip"){
          const value = e.target.value;
          if(regex.test(e.target.value)){
            setData({ ...data, zip: e.target.value });
            setError({...error, zip: "" })
          }

          if(value === "" || value === undefined || value === null){
          setError({...error, zip: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "contactPerson"){
          const value = e.target.value;
          setData({ ...data, contactPerson: e.target.value });
          setError({...error, contactPerson: "" })

          if(value === "" || value === undefined || value === null){
          setError({...error, contactPerson: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "email"){
          const value = e.target.value;
          setData({ ...data, email: e.target.value });
          setError({...error, email: "" })

          if(value === "" || value === undefined || value === null){
          setError({...error, email: "This field cannot be blank" })
          }
        }

        else if(e.target.name === "reliableHealthCare"){
          setData({ ...data, reliableHealthCare: e.target.checked  });
        }

      else {
        setData({
          ...data,
          [e.target.name]: e.target.value,
        });

        if(e.target.name === "careFacilityName"){
          setError({...error, careFacilityName: "" })
        }

        if(e.target.name === "address"){
            setError({...error, address: "" })
          }

        if(e.target.name === "city"){
          setError({...error, city: "" })
          }

        if(e.target.name === "state"){
          setError({...error, state: "" })
          }

        if(e.target.name === "zip"){
          setError({...error, zip: "" })
          }

        if(e.target.name === "contactPerson"){
          setError({...error, contactPerson: "" })
        }
      }
    };
  
    const validateAccountField = (e) => {
      if (!e.target.value.trim()) {
        setFocus(false);
      }
      if (e.target.value.length < 10) {
        setAcntNumError({ accountNumber: "Please enter valid account no." });
        setError({ ...error, accountNumber: "Please enter valid account no." })
      } else {
        setAcntNumError({});
        setError({ ...error, accountNumber: "" })
      }
    };
  
    const validatePhoneField = (phone) => {
      let err = false;
      if (phone.trim()) {
        setFocus(false);
      }
      
      if (phone.length < 10 || phone.length > 10) {
        setPhoneError({ phone: "Please enter valid phone no." });
        setError({ ...error, phone: "Please enter valid phone no." })
        err = true;
      } 
      else {
        setPhoneError({});
      }
      return err;
    };
  
    const validate = () => {
      const newErrors = {};
      let err = validatePhoneField(data.phone);
      Object.keys(data).forEach((key) => {
        if (key !== "id" && !data[key] && key!== "reliableHealth"
        ) {
          newErrors[key] = "This field cannot be blank";
        }
      });
      setError(newErrors);
      return (
         
        Object.keys(newErrors).length === 0 &&
        Object.keys(emailError).length === 0 &&
        Object.keys(acntNumError).length === 0 &&
        Object.keys(phoneError).length === 0 && !err 
        
      );
    };
  
    const handleEmailError = (emailError) => {
      if (emailError) {
        setEmailError({ email: emailError });
      } else {
        setEmailError({});
      }
    };
  
    const onClickSubmit = () => {
      try {
        if (validate()) {
          setFacilityName(data.careFacilityName);
          const careFacilityData = getCareFacilityData();
          createStandAloneCarefacility(careFacilityData);          
        }
      } catch (error) {
        console.log(error);
      }
    };

    const createStandAloneCarefacility= async(careFacilityData) =>{
      try{
        const response = await axiosInstance.post(`${createCareFacility}`,
              JSON.stringify(careFacilityData));
              if (response.data.isSuccess) {
                setSuccess(true);
                setErrorFlag(false);
                resetForm();
              } 
              else if(!response.data.isSuccess && response.data.httpStatus== "BAD_REQUEST"){
                setErrorMsg(response.data.Message);
                setErrorFlag(true);
                setSuccess(false);
              }
              else{
                seterrormodalOpen(true);
              }
              setOpen(true);
        }
        catch (error) {
          console.log(error);
          seterrormodalOpen(true);
        }
    }
  
    const getCareFacilityData = () => {
      return {
        id: data.id,
        accountNumber: data.accountNumber,
        careFacilityName: data.careFacilityName,
        address: data.address,
        city: data.city,
        state: data.state,
        zip: data.zip,
        phone: data.phone,
        contactPerson: data.contactPerson,
        email: data.email,
        isReliable: data.reliableHealth === "Yes" ? 1 : 0,
        createdBy: storeuser.email,
        childList: []
      };
    };
  
    const handleClose = () => {
      setOpen(false);
      navigate("/admin/careFacilityListings");
    };
  
    const resetForm = () => {
      setData(facilityData);
      setError({});
      setPhoneError({});
      setAcntNumError({});
      setEmailError({});
    };
  
    return (
      <div style={{height:"auto", paddingBottom: "10px"}}>
  
        <Box
          sx={{
            position: "relative",
            left: "1%",
            flexDirection: "column",
            width: "95%",
            alignItems: "center",
            p: "1% 1%",
            backgroundColor: "#fcfcfc",
            //border: "2px solid #dfe3e8",
            //borderRadius: "20px",
          }}
        >
         
          <br></br>
          <Grid>
            <Grid
              item
              sx={{
                p: "5px 8px",
                border: "1.5px solid #dfe3e8",
                borderRadius: "5px",
                backgroundColor: "white",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", height: "65px", m: "5px 0" }}
              >
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Company Name <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Company Name"
                    //onPaste={changeHandler}
                    name="careFacilityName"
                    value={data.careFacilityName}
                    title={data.careFacilityName}
                    onChange={changeHandler}
                    error={error.careFacilityName}
                    helperText={
                      error.careFacilityName ? error.careFacilityName : ""
                    }
                    inputProps={{ readOnly: action == "edit" ? true : false, maxLength: 500 }}
                    InputProps={{
                      className: action == "edit" ? "Mui-disabled" : undefined,
                    }}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Account Number <span id="req-field">*</span>
                  </p>
                  <TextField
                    label=""
                    type={showAccnt ? "text" : "password"}
                    title={data.accountNumber}
                    placeholder="Account Number"
                    name="accountNumber"
                    onChange={changeHandler}
                    value={data.accountNumber}
                    required
                    inputProps={{
                      maxLength: 10,
                      minLength: 10,
                      readOnly: action == "edit" ? true : false,
                    }}
                    error={acntNumError.accountNumber || error.accountNumber}
                    onBlur={validateAccountField}
                    helperText={error.accountNumber || acntNumError.accountNumber}
                    sx={{ maxWidth: "210px" }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowAccnt(!showAccnt)}
                              edge="end"
                            >
                              {showAccnt ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                      ),
                      className: action == "edit" ? "Mui-disabled" : undefined,
                    }}
                    onFocus={() => setFocus(true)}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Address <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Address"
                    name="address"
                    onChange={changeHandler}
                    inputProps={{maxLength: 500}}
                    value={data.address}
                    error={error.address}
                    helperText={error.address ? error.address : ""}
                  />
                </Box>
              </Stack>
  
              <Divider
                variant="fullwidth"
                sx={{ backgroundColor: "#dfe3e8" }}
              ></Divider>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", height: "65px", m: "5px 0" }}
              >
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    City <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="City"
                    name="city"
                    value={data.city}
                    onChange={changeHandler}
                    inputProps={{maxLength: 100}}
                    error={error.city}
                    helperText={error.city ? error.city : ""}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    State <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="State"
                    name="state"
                    value={data.state}
                    onChange={changeHandler}
                    inputProps={{maxLength: 100}}
                    error={error.state}
                    helperText={error.state ? error.state : ""}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Zip Code <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Zip Code"
                    name="zip"
                    value={data.zip}
                    onChange={changeHandler}
                    error={error.zip}
                    //type="number"
                    className="number-input"
                    helperText={error.zip ? error.zip : ""}
                    inputProps={{ maxLength: 100, minLength: 6 }}
                  />
                </Box>
              </Stack>
  
              <Divider
                variant="fullwidth"
                sx={{ backgroundColor: "#dfe3e8" }}
              ></Divider>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", height: "65px", m: "5px 0" }}
              >
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Telephone No. <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Telephone No."
                    name="phone"
                    className="number-input"
                    value={data.phone}
                    inputProps={{ 
                      maxLength: 10, minLength: 10 
                    }}
                    onChange={changeHandler}
                    error={phoneError.phone || error.phone}
                    onBlur={(e)=>validatePhoneField(e.target.value)}
                    helperText={error.phone || phoneError.phone}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Point of Contact <span id="req-field">*</span>
                  </p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Contact Name"
                    name="contactPerson"
                    value={data.contactPerson}
                    onChange={changeHandler}
                    inputProps={{maxLength: 100}}
                    error={error.contactPerson}
                    helperText={error.contactPerson ? error.contactPerson : ""}
                  />
                </Box>
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Email <span id="req-field">*</span>
                  </p>
                  <EmailInputField
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Email"
                    name="email"
                    value={data.email}
                    required
                    onChange={changeHandler}
                    inputProps={{maxLength: 100}}
                    onEmailError={handleEmailError}
                    error={emailError.email || error.email}
                    helperText={emailError.email ? emailError.email : error.email}
                  />
                </Box>
              </Stack>

              <Divider
                variant="fullwidth"
                sx={{ backgroundColor: "#dfe3e8" }}
              ></Divider>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", height: "65px", m: "5px 0" }}
              >
                <Box
                  display="flex"
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p className="input-label">
                    Reliable Health
                  </p>
                  <FormControl>
                    <RadioGroup
                        id="reliableHealth"
                        name="radio-buttons-group"
                        defaultValue="Yes"
                        value={data.reliableHealth}
                        onChange={changeHandler}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "150px",
                            }}
                          >
                          <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                }}
                                 >
                                <Radio
                                   sx={{ "& .PrivateSwitchBase-input":{padding: "9px 0px 9px 0px"},pr: "0" }}
                                    variant="outlined"
                                    checked={data.reliableHealth === "Yes"}
                                    onChange={changeHandler}
                                    name="reliableHealth"
                                    value="Yes"
                                    label="Yes"
                                    />{" "}
                                    <span>Yes</span>
                                    </Box>
                                    <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Radio
                                          sx={{ "& .MuiRadio-root":{padding: "9px 0px 9px 0px"},pr: "0" }}
                                          variant="outlined"
                                          checked={data.reliableHealth === "No"}
                                          onChange={changeHandler}
                                          name="reliableHealth"
                                          value="No"
                                          label="No"
                                        />{" "}
                                        <span>No</span>
                                      </Box>
                                    </RadioGroup>              
                                  </FormControl>
                 
                </Box>
              </Stack>
            </Grid>
  
            <Grid
              item
              xs={12}
              sx={{
                mt: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >

              <Box>
                {action !== "edit" && (
                  <Button
                    id="psa-cf-rst-btn"
                    onClick={resetForm}
                    variant="outlined"
                    sx={{ width: "120px" }}
                  >
                    Reset
                  </Button>
                )}
                <Link to="/admin/careFacilityListings">
                  <Button variant="outlined" id="user-back-btn">
                    Back
                  </Button>
                </Link>
              </Box>
  
              <Button
                id="facility-submit-btn"
                variant="contained"
                onClick={onClickSubmit}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
          <Modal open={open} onClose={() => setOpen(false)}>
            <>
              {success && (
                <Box sx={style}>
                  <IconButton
                    sx={{ border: "2px solid green", boxShadow: "none" }}
                  >
                    <Check sx={{ color: "green" }} />
                  </IconButton>
                  <p>
                    {facilityName} {displayMsg} successfully!
                  </p>
                  <Button
                    id="modal-close-btn"
                    variant="contained"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Box>
              )}
              {errorFlag && (
                <Box sx={style}>
                  <IconButton sx={{ border: "2px solid red", boxShadow: "none" }}>
                    <Error sx={{ color: "red" }} />
                  </IconButton>
                  <p> {errorMsg}</p>
                  <Button
                    id="modal-close-btn"
                    variant="contained"
                    onClick={() => setOpen(false)}
                  >
                    Close
                  </Button>
                </Box>
              )}
            </>
          </Modal>
        </Box>
        {errormodalopen && (
			<ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
		  )}
      </div>
    );
  }
  
  export default StandAloneCareFacility;
  